// Quick preview that shows up on public discovery
import styled from 'styled-components'
import Link from 'next/link'

const SkinPreviewStyled = styled.div`
  width: 300px;
  background: rgb(236, 236, 236);
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  margin-bottom: 20px;
`
const SkinImageStyled = styled.div`
  width: 100px; height: 100px;
`

const SkinImage = ({ texName, skin }) => {
  const texURL = skin.textures[texName] || `/textures/${texName}.png`

  return (
    <SkinImageStyled>
      <img width={100} height={100} src={texURL} />
    </SkinImageStyled>
  )
}

const SkinPreview = ({ skin }) => {
  return (
    <Link href={`/skins/${skin.skinName.replace(/ /g, '-')}`}>
      <a style={{ textDecoration: 'none' }}>
        <SkinPreviewStyled>
          <SkinImage texName='tile1' skin={skin} />
          <SkinImage texName='tile2' skin={skin} />
          <SkinImage texName='tile3' skin={skin} />
          <SkinImage texName='tileUnrevealed' skin={skin} />
          <SkinImage texName='tileFlagged' skin={skin} />
          <SkinImage texName='tileRevealed' skin={skin} />

          <div style={{ padding: '0 20px' }}>
            <h3 style={{ marginBottom: 10 }}>{skin.skinName.toUpperCase()}</h3>
            <p style={{ marginTop: 0 }}>{skin.downloadCount} downloads</p>
          </div>
        </SkinPreviewStyled>
      </a>
    </Link>
  )
}

export default SkinPreview
